/**
 * "A day inside iAdvocate" — the full logged-in criminal dashboard preview
 * (design screen 1b), so a visitor on the logged-out landing sees exactly what
 * the workspace looks like before signing in. MARKETING-STATIC (see
 * previews/previewData.ts). Criminal only: corporate is coming soon, so its
 * preview is gone (Ajay, 2026-11-01).
 */
import CriminalHomePreview from './previews/CriminalHomePreview';
import { sectionLabel } from './homepageContent';

export default function InsideSection() {
  return (
    <section
      id="inside"
      className="scroll-mt-16 px-5 sm:px-8 lg:px-14 py-20 border-t border-brass-hairline"
    >
      <div className="flex flex-wrap items-baseline justify-between gap-4">
        <h2 className="font-display font-normal text-3xl lg:text-[44px] text-parchment">
          A day inside{' '}
          <em className="font-editorial italic text-brass">iAdvocate.</em>
        </h2>
        <span className="font-plex text-[11px] tracking-[0.3em] text-brass">
          {sectionLabel('inside')}
        </span>
      </div>
      <p className="text-base leading-[1.7] text-chamber-muted-bright max-w-[560px] mt-4">
        Sign in and your practice is already laid out — the criminal daily
        docket, with the clocks that matter counting down beside it.
      </p>

      <div className="mt-12">
        <CriminalHomePreview />
      </div>
    </section>
  );
}
